import { Component, Inject } from '@angular/core';
import { AuthService } from '@auth0/auth0-angular';
import { ApiService } from '../api/api.service';
import { CommonModule } from '@angular/common';
import { RouterOutlet } from '@angular/router';
import {  KENDO_LAYOUT } from "@progress/kendo-angular-layout";
import { BadgeComponent } from "../badge/badge.component";

@Component({
  selector: 'auth-content',
  templateUrl: './auth-content.component.html',
  styles: `.login {
    --kendo-color-primary: var(--skov-secondary);

    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100vh;
  }
  .login-btn {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: end;
    
  }
  .badge {
    display: flex;
    justify-content: end;
  }
  `,
  imports: [CommonModule, RouterOutlet, KENDO_LAYOUT, BadgeComponent]
})
export class AuthContentComponent {
  constructor(public auth: AuthService,public apiService: ApiService) {
    
  }


}
